"use strict";

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', evt => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.activeElement = null;
  }
  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('#cart-icon-bubble, .grJS-cart-opener');
    cartLinks.forEach(cartLink => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', event => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', event => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }
  connectedCallback() {
    this.addEventListener('open', this.open.bind(this));
    this.addEventListener('close', this.close.bind(this));
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    // if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.gr-drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.gr-drawer__inner') || this.querySelector('.gr-drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, {
      once: true
    });
    if (!(window.innerWidth >= 1280 && document.body.classList.contains('gr-drawer-jump'))) {
      document.body.classList.add('overflow-hidden');
    }
  }
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', event => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  renderContents(parsedState, op) {
    // gr cart engine present: NEVER swap in the Liquid HTML from the add.js
    // payload. That swap painted Liquid-computed totals (different rounding
    // and, with Shopify Markets, possibly a different price context) which
    // the engine then overwrote with its own numbers ~0.5s later — the
    // visible price dip-and-bounce after every add. The engine renders from
    // /cart.js (single price authority) and does the structural HTML swap
    // later, idle-gated, repainting its own totals in the same task.
    if (window.grRefreshCartState) {
      this.classList.remove('is-empty');
      const grInner = this.querySelector('.gr-drawer__inner');
      if (grInner) grInner.classList.remove('is-empty');
      window.grRefreshCartState();
      if (window.grScheduleDrawerRerender) window.grScheduleDrawerRerender();
      if (typeof freeUpdate === 'function') freeUpdate();
      if (typeof op == 'undefined') {
        setTimeout(() => {
          this.open();
        });
      }
      setTimeout(function () {
        document.querySelector('cart-drawer').classList.remove('cart-loading');
      }, 250);
      this.initializeEventListeners();
      return;
    }
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        try {
          const responseData = JSON.parse(xhr.responseText);
          if (JSON.stringify(responseData?.items) !== JSON.stringify(parsedState?.items)) {
            const itemOrder = (window?.cart?.items || responseData?.items).map(item => item.key);
            responseData.items.sort((a, b) => itemOrder.indexOf(a.key) - itemOrder.indexOf(b.key));
          }
          window.cart = responseData;
          window.cart['sections'] = parsedState['sections'];
        } catch (error) {
          console.error('Error parsing JSON response:', error);
        }
      }
    };
    xhr.open("GET", "/cart.js", true);
    xhr.send();

    // Ensure the drawer is not marked as empty
    const drawerInner = this.querySelector('.gr-drawer__inner');
    if (drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }
    this.productId = parsedState.id;

    // Iterate over sections to render
    this.getSectionsToRender().forEach(section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      const sectionHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (section.id === "cart-drawer" || section.id === "CartDrawer") {
        const parser = new DOMParser();
        const parsedDoc = parser.parseFromString(sectionHTML, "text/html");
        const container = parsedDoc.querySelector("#CartDrawer-CartItems .gr-drawer-list");
        const linesSortOrder = (parsedState?.items || window?.cart?.items).map(item => item.key);
        const sortedElements = Array.from(container.querySelectorAll(".gr-drawer-list__item"));
        sortedElements.sort((a, b) => {
          const lineA = a.querySelector(".gr-cart-item");
          const lineB = b.querySelector(".gr-cart-item");
          return linesSortOrder.indexOf(lineA.dataset.id) - linesSortOrder.indexOf(lineB.dataset.id);
        });
        sortedElements.forEach(element => {
          container.appendChild(element);
        });
        sectionElement.innerHTML = parsedDoc.body.innerHTML;
      } else {
        sectionElement.innerHTML = sectionHTML;
      }
    });

    // Call freeUpdate
    freeUpdate();
    if (typeof op == 'undefined') {
      setTimeout(() => {
        this.open();
      });
    }
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    setTimeout(function () {
      document.querySelector('cart-drawer').classList.remove('cart-loading');
    }, 250);
    this.initializeEventListeners();
  }
  getSectionInnerHTML(html) {
    let selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.shopify-section';
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [{
      id: 'cart-drawer',
      selector: '#CartDrawer'
    }, {
      id: 'cart-icon-bubble'
    }];
  }
  getSectionDOM(html) {
    let selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.shopify-section';
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
  initializeEventListeners() {
    document.addEventListener('click', function (event) {
      const drawerPopup = document.querySelector('.gr-drawer-popup');
      const showPopupButton = event.target.closest('.gr-cart-drawer__show-popup');
      const closePopupButton = event.target.closest('.gr-drawer-popup__close');
      const popupOverlay = event.target.closest('#CartDrawerPopup-Overlay');
      if (showPopupButton && drawerPopup) {
        drawerPopup.classList.add('gr-open');
      } else if (drawerPopup && closePopupButton || popupOverlay) {
        drawerPopup.classList.remove('gr-open');
      }
    });
  }
}
customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [{
      id: 'CartDrawer',
      section: 'cart-drawer',
      selector: '.gr-drawer__inner'
    }, {
      id: 'CartMobOpener',
      section: 'cart-drawer',
      selector: '.gr-cart-draewer-mob-opener'
    }, {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
class GrSelectText extends HTMLElement {
  constructor() {
    super();
    this.selectTrigger = this.querySelector('.gr-select-text__trigger');
  }
  connectedCallback() {
    this.selectTrigger.addEventListener('click', this.toggleActive.bind(this));
    document.addEventListener('click', this.handleDocumentClick.bind(this));
  }
  toggleActive() {
    this.selectTrigger.classList.toggle('gr-active');
  }
  handleDocumentClick(event) {
    if (!this.selectTrigger.contains(event.target)) {
      this.selectTrigger.classList.remove('gr-active');
    }
  }
}
customElements.define('gr-select-text', GrSelectText);
document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.querySelector('.gr-drawer');
  const mainElement = document.querySelector('.gr-page-with-cart__cart-wrap');
  const drawerParent = document.querySelector('cart-drawer-wrapper');
  const bodyDrawerJump = document.body.classList.contains('gr-drawer-jump');
  function moveCartDrawer() {
    if (bodyDrawerJump) {
      if (!cartDrawer || !mainElement || !drawerParent) {
        console.error('One or more elements are missing:', {
          cartDrawer,
          mainElement,
          drawerParent
        });
        return;
      }
      if (window.innerWidth >= 1280 && bodyDrawerJump) {
        if (cartDrawer && !mainElement.contains(cartDrawer)) {
          mainElement.appendChild(cartDrawer);
        }
      } else {
        if (cartDrawer && !drawerParent.contains(cartDrawer)) {
          drawerParent.prepend(cartDrawer);
        }
      }
    }
  }
  moveCartDrawer();
  window.addEventListener('resize', function () {
    moveCartDrawer();
  });
  const cartDrawerElement = document.querySelector('cart-drawer');
  if (cartDrawerElement) {
    cartDrawerElement.initializeEventListeners();
  }
  document.addEventListener('click', function (event) {
    if (event.target.closest('.grJS-cart-opener')) {
      cartDrawer.classList.toggle('active');
      document.body.classList.toggle('overflow-hidden');
    }
  });
});